<template>
    <div>{{formattedValue}}</div>
</template>

<script>
    import emptyInnerHTML from '@/common/helpers/empty-inner-html';
    import _ from '@/common/helpers';
    import {DateTimeFormats} from '@/common/datetime-formats';

    export default {
        name: 'attribute-value',
        props: {
            value: {
                required: true,
            },
            name: {
                required: true,
            },
        },
        computed: {
            formattedValue() {
                // TODO consider using a render function instead
                // and recursively go through values (arrays)
                const {value} = this;
                if (_.isObject(value)) {
                    // TODO handle objects
                    return _.unKebabCase(this.name);
                }
                if (Array.isArray(value)) {
                    if (value.length === 0) {
                        return emptyInnerHTML;
                    }
                    return value
                        .map(item => (_.isObject(item) || Array.isArray(item)
                            ? _.unCamelCase(this.name)
                            : item))
                        .join(', ');
                }
                const primitiveConversion = (primitive) => {
                    if (typeof primitive === 'boolean') {
                        return primitive ? 'Yes' : 'No';
                    /*
                        It seems kinda strange to remove dashes from data _value_
                        Conside IDs, website names ...

                    } if (typeof primitive === 'string' && primitive.indexOf('-')) {
                        return _.unKebabCase(primitive, false);
                    */
                    } if (typeof primitive === 'string' && _.isValidISODate(primitive)) {
                        return this.$tz().readUTC(primitive).format(DateTimeFormats.longDateTime);
                    } if (typeof primitive === 'number') {
                        return this.$filters.number(primitive);
                    }
                    return String(primitive);
                };
                return _.isBlank(value) ? emptyInnerHTML : primitiveConversion(value);
            },
        },
    };
</script>
